import { render, staticRenderFns } from "./WardflexCalculator.vue?vue&type=template&id=1b276386"
import script from "./WardflexCalculator.vue?vue&type=script&lang=js"
export * from "./WardflexCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports